export const parseHTMLContent = (
  content: string,
  json: Record<string, unknown>,
  reset = true,
) => {
  const parser = new DOMParser();
  const htmlDoc = parser.parseFromString(content, "text/html");

  const classifiedElements = htmlDoc.querySelectorAll(
    "[data-ai-classification]",
  );

  const leafNodes = Array.from(classifiedElements).filter((element) => {
    return element.querySelectorAll("[data-ai-classification]").length === 0;
  });

  leafNodes.forEach((leafNode) => {
    const property = leafNode.getAttribute("data-ai-classification");
    if (!property) return;
    const originalText = leafNode.textContent || "";
    const replacementText = (json[property] ?? originalText) as
      | string
      | number
      | boolean;
    let highestParent = leafNode;
    let currentElement = leafNode.parentElement;

    while (currentElement?.hasAttribute("data-ai-classification")) {
      highestParent = currentElement;
      currentElement = currentElement.parentElement;
    }

    const clone = highestParent.cloneNode(true) as HTMLElement;
    clone.textContent = replacementText as string;
    if (!reset && property) {
      clone.setAttribute("data-ai-classification", property);
    } else if (reset) {
      clone.removeAttribute("data-ai-classification");
      const nestedClassified = clone.querySelectorAll(
        "[data-ai-classification]",
      );
      nestedClassified.forEach((el) =>
        el.removeAttribute("data-ai-classification"),
      );
    }

    highestParent.parentNode?.replaceChild(clone, highestParent);
  });

  removeEmptyTextNodes(htmlDoc.body);
  return serializeHTML(htmlDoc.body);
};

function removeEmptyTextNodes(node: Node) {
  const childNodes = Array.from(node.childNodes);

  for (const child of childNodes) {
    if (
      child.nodeType === Node.TEXT_NODE &&
      !/\S/.test(child.nodeValue || "")
    ) {
      node.removeChild(child);
    } else if (child.nodeType === Node.ELEMENT_NODE) {
      removeEmptyTextNodes(child);
    }
  }
}

function serializeHTML(element: HTMLElement) {
  return element.innerHTML
    .replace(
      /\{\{\{([^}]+)\}\}\}/g,
      '<span contenteditable="false" class="fast-versioning">{{{$1}}}</span>',
    )
    .replace(
      /\{\{([^}]+)\}\}/g,
      '<span contenteditable="false" class="fast-versioning">{{$1}}</span>',
    );
}
